import React, { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Grid, Typography, Tabs, Tab } from '@mui/material';
import IntlInfo from './IntlInfo';
import IntlMembers from './IntlMembers';
import IntlCommittees from './StandingCommittees';
import IntlBoard from './Board';
import IntlAppointments from './StandingAppts';

const IntlDetail = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = useCallback(
    (key, value) => {
      if (!value || value === '') {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const convertTextToTabIndex = (text) => {
    switch (text) {
      case 'info':
        return 0;
      case 'board':
        return 1;
      case 'appointments':
        return 2;
      case 'committees':
        return 3;
      case 'members':
        return 4;
      default:
        return 0;
    }
  };

  const [tabSelected, setTabSelected] = useState(
    searchParams.get('tab') ? convertTextToTabIndex(searchParams.get('tab')) : 0
  );

  const converTabIndexToText = (index) => {
    switch (index) {
      case 0:
        return 'info';
      case 1:
        return 'board';
      case 2:
        return 'appointments';
      case 3:
        return 'committees';
      case 4:
        return 'members';
      default:
        return '';
    }
  };

  useEffect(() => {
    updateSearchParams('tab', converTabIndexToText(tabSelected));
  }, [tabSelected, updateSearchParams]);

  return (
    <Grid container>
      <Grid item xs={12} padding textAlign={'center'}>
        <Typography variant="h4">International</Typography>
      </Grid>
      <Grid item xs={12} padding>
        <Tabs
          value={tabSelected}
          onChange={(event, newValue) => setTabSelected(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Info" />
          <Tab label="Executive Board" />
          <Tab label="Standing Appointments" />
          <Tab label="Board of Trustees / Standing Committees" />
          <Tab label="Overseas Contacts" />
        </Tabs>
      </Grid>
      <Grid item xs={12} padding>
        {tabSelected === 0 && <IntlInfo />}
        {tabSelected === 1 && <IntlBoard />}
        {tabSelected === 2 && <IntlAppointments />}
        {tabSelected === 3 && <IntlCommittees />}
        {tabSelected === 4 && <IntlMembers />}
      </Grid>
    </Grid>
  );
};

export default IntlDetail;
